import { AxiosError } from 'axios';
import { createAction, createAsyncAction } from 'typesafe-actions';
import { Project, ProjectParams } from './types';
export const GET_PROJECT_LIST = 'projects/GET_PROJECT_LIST';
export const GET_PROJECT_LIST_SUCCESS = 'projects/GET_PROJECT_LIST_SUCCESS';
export const GET_PROJECT_LIST_ERROR = 'projects/GET_PROJECT_LIST_ERROR';

export const UPDATE_PROJECT = 'projects/UPDATE_PROJECT';
export const UPDATE_PROJECT_SUCCESS = 'projects/UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_ERROR = 'projects/UPDATE_PROJECT_ERROR';

export const CREATE_PROJECT = 'projects/CREATE_PROJECT';
export const CREATE_PROJECT_SUCCESS = 'projects/CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_ERROR = 'projects/CREATE_PROJECT_ERROR';

export const DELETE_PROJECT = 'projects/DELETE_PROJECT';
export const DELETE_PROJECT_SUCCESS = 'projects/DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_ERROR = 'projects/DELETE_PROJECT_ERROR';

export const SET_CURRENT_PROJECT_ID = 'projects/SET_CURRENT_PROJECT_ID';
export const SET_CURRENT_PROJECT_NAME = 'projects/SET_CURRENT_PROJECT_NAME';

export const GET_PROJECT_DETAIL = 'projects/GET_PROJECT_DETAIL';
export const GET_PROJECT_DETAIL_SUCCESS = 'projects/GET_PROJECT_DETAIL_SUCCESS';
export const GET_PROJECT_DETAIL_ERROR = 'projects/GET_PROJECT_DETAIL_ERROR';

export const UPLOAD_PROJECT_SHARED_FILE = 'projects/UPLOAD_PROJECT_SHARED_FILE';
export const UPLOAD_PROJECT_SHARED_FILE_SUCCESS =
  'projects/UPLOAD_PROJECT_SHARED_FILE_SUCCESS';
export const UPLOAD_PROJECT_SHARED_FILE_ERROR =
  'projects/UPLOAD_PROJECT_SHARED_FILE_ERROR';

export const REMOVE_PROJECT_SHARED_FILE = 'projects/REMOVE_PROJECT_SHARED_FILE';
export const REMOVE_PROJECT_SHARED_FILE_SUCCESS =
  'projects/REMOVE_PROJECT_SHARED_FILE_SUCCESS';
export const REMOVE_PROJECT_SHARED_FILE_ERROR =
  'projects/REMOVE_PROJECT_SHARED_FILE_ERROR';

export const getProjectListAsync = createAsyncAction(
  GET_PROJECT_LIST,
  GET_PROJECT_LIST_SUCCESS,
  GET_PROJECT_LIST_ERROR,
)<ProjectParams, Project[], AxiosError>();

export const updateProjectAsync = createAsyncAction(
  UPDATE_PROJECT,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_ERROR,
)<ProjectParams, Project, AxiosError>();

export const createProjectAsync = createAsyncAction(
  CREATE_PROJECT,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_ERROR,
)<ProjectParams, Project, AxiosError>();

export const deleteProjectAsync = createAsyncAction(
  DELETE_PROJECT,
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_ERROR,
)<ProjectParams, number, AxiosError>();

export const setCurrentProjectId = createAction(
  SET_CURRENT_PROJECT_ID,
)<number>();

export const setCurrentProjectName = createAction(
  SET_CURRENT_PROJECT_NAME,
)<string>();

export const getProjectDetailAsync = createAsyncAction(
  GET_PROJECT_DETAIL,
  GET_PROJECT_DETAIL_SUCCESS,
  GET_PROJECT_DETAIL_ERROR,
)<ProjectParams, Project, AxiosError>();
